import React, { useState, useEffect, useContext } from "react";
import "./appBranchList.css";
import Image from "../../Assets/BranchImage.svg";
import Arrow from "../../Assets/ArrowIcon.png";
import Line from "../../Assets/Line.svg";
import { isNullOrEmpty } from "../../Utils/TextUtils";
import { BranchData } from "../../Redux/Action";
import { useDispatch } from "react-redux";
import { PopupContext } from "../../Context/PopupContext";
import { useTranslation } from "react-i18next";

const BranchList = ({ setIsModalOpen, branchData }) => {
  let dispatch = useDispatch();
  const {
    setIsBranchSelectedFromPopUp,
    setIsBranchSelectedFromNavbar,
    isBranchSelectedFromPopUp,
    isBranchSelectedFromNavbar,
  } = useContext(PopupContext);

  //#region localization code
  const { t, i18n } = useTranslation();
  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  return (
    <div
      className="Branch_Main_Container"
      onClick={() => {
        dispatch(BranchData(branchData));
        localStorage.setItem("branchData", JSON.stringify(branchData));
        localStorage.setItem("interval", branchData.slot_interval);
        setIsBranchSelectedFromPopUp(true);
        setIsBranchSelectedFromNavbar(false);
        // localStorage.setItem("branchSelectedFromPopup", true);
        setIsModalOpen(false);
      }}
    >
      <div className="Branch_Address_Wrapper">
        <img src={Image} alt="Image_" className="Branch_ImageStyle" />
        <div className="Branch_Text_Wrapper">
          <div className="Branch_Text_Style">
            {!isNullOrEmpty(branchData)
              ? isArabic
                ? branchData.name_ar
                  ? branchData.name_ar
                  : t("not_specified")
                : branchData.name
                ? branchData.name
                : t("not_specified")
              : t("not_specified")}
          </div>
          <div className="Branch_Ardress_Text_Style">
            {!isNullOrEmpty(branchData && branchData.address)
              ? branchData.address
              : t("not_specified")}
          </div>
        </div>
      </div>
      <div className="Branch_Arrow_Wrapper">
        <img src={Line} alt="Image_" className={"Branch_Line_ImageStyle"} />
        <img src={Arrow} alt="Image_" className={"Branch_Arrow_ImageStyle"} />
      </div>
    </div>
  );
};

export default BranchList;
